// @flow
import React from 'react';
import useLazyLoadIntersection from '../../hooks/useLazyLoadIntersection';
import { groupsOf } from '../../helpers/utils';
import LandingIcon from './LandingPageIcon';
import LegacyLink from '../Common/LegacyLink';

const groupsOfThree = groupsOf(3);

const renderNearbyLocation = (location, triggered) => (
  <li className="c-nearby-location">
    {triggered ? <LandingIcon iconName="nearby_locations" /> : null}
    <LegacyLink to={location.url}>{location.name}</LegacyLink>
  </li>
);

type Props = {
  nearbyLocations: Array<any>,
  nearbyLocationsTitle: string,
  name: string
};

const NearbyLocations = ({
  nearbyLocations,
  nearbyLocationsTitle,
  name
}: Props) => {
  const [ref, triggered] = useLazyLoadIntersection(100);

  if (!nearbyLocations || !nearbyLocations.length) {
    return <div style={{ display: 'none' }} ref={ref} />;
  }

  return (
    <div className="c-nearby-locations-wrapper">
      <div className="c-nearby-locations" ref={ref}>
        <div className="c-amenities">
          <h3>{nearbyLocationsTitle.replace('%name%', name)}</h3>
          <div>
            {groupsOfThree(nearbyLocations).map((group) => (
              <ul>
                {group.map((loc) => renderNearbyLocation(loc, triggered))}
              </ul>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NearbyLocations;
